import type { Tier } from '@app-iptv/shared'
import { useEffect } from 'react'
import type { ReactNode } from 'react'


interface TierProviderProps {
  tier: Tier
  children: ReactNode
}

// Aplica data-tier no <html> pra ativar preset CSS correto.
// Persiste pra evitar flash visual ao navegar.
export function TierProvider({ tier, children }: TierProviderProps) {
  useEffect(() => {
    document.documentElement.dataset['tier'] = tier
    return () => {
      delete document.documentElement.dataset['tier']
    }
  }, [tier])

  return <>{children}</>
}
